import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import QueueMusicIcon from '@mui/icons-material/QueueMusic';
import SearchIcon from '@mui/icons-material/Search';
import { SvgIconTypeMap } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { Link, LinkProps } from 'react-router-dom';

import NewTabLink from 'components/b2c/NewTabLink';
import { PATHS } from 'constants/pathsB2c';

export interface Tab {
  label: string;
  Icon: OverridableComponent<SvgIconTypeMap<object, 'svg'>>;
  path: string;
  Component: React.ElementType<LinkProps>;
}

export const tabs: Tab[] = [
  {
    label: 'navigation-bar.search',
    Icon: SearchIcon,
    path: PATHS.WEB_PLAYER,
    Component: Link,
  },
  {
    label: 'navigation-bar.playlist',
    Icon: PlayArrowIcon,
    path: PATHS.WAITING_LIST,
    Component: Link,
  },
  {
    label: 'navigation-bar.my-playlists',
    Icon: QueueMusicIcon,
    path: PATHS.MY_PLAYLISTS,
    Component: Link,
  },
  {
    label: 'navigation-bar.profile',
    Icon: AccountCircleIcon,
    path: PATHS.CLIENT,
    Component: NewTabLink,
  },
];
